"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMenuItem = exports.OfferTitleContainer = exports.OfferApplicationCountBadge = exports.OfferActiveStatusBadge = exports.StyledMenu = exports.ActionButtonsWrap = exports.SelectionAndFinishingButtonsWrap = exports.ActionsMenuWrap = exports.ActionsContent = exports.ApplicantsCountText = exports.LineWrap = exports.HeaderWrap = exports.ArrowDown = exports.RightArrow = exports.HiringProcess = exports.OfferName = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
const streamline_icon_arrow_right_1_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-arrow-right-1.svg"));
const streamline_icon_arrow_down_1_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-arrow-down-1.svg"));
const elements_1 = require("@src/components/elements");
exports.OfferName = styled_components_1.default.div `
	color: ${props => props.theme.color.linkedin};
	&:hover {
		cursor: pointer;
	}
`;
exports.HiringProcess = styled_components_1.default.div `
	color: ${props => props.theme.color.gray5};
	display: flex;
	align-items: center;
	${(0, styled_breakpoints_1.down)('xs')} {
		margin-bottom: 1rem;
	}
`;
exports.RightArrow = (0, styled_components_1.default)(streamline_icon_arrow_right_1_svg_1.default) `
	height: 10px;
	margin: 0 0.5rem;
`;
exports.ArrowDown = (0, styled_components_1.default)(streamline_icon_arrow_down_1_svg_1.default) `
	height: 10px;
	margin-left: 0.25rem;
`;
exports.HeaderWrap = styled_components_1.default.div `
	margin: 0 0 0.5rem;
	padding: 0.5rem;
`;
exports.LineWrap = styled_components_1.default.div `
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;

	${(0, styled_breakpoints_1.down)('xs')} {
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
	}
`;
exports.ApplicantsCountText = styled_components_1.default.div `
	color: ${props => props.theme.color.brand1};
`;
exports.ActionsContent = styled_components_1.default.div `
	min-height: 2rem;
	margin-top: 1rem;

	${(0, styled_breakpoints_1.down)('xs')} {
		height: auto;
	}
`;
exports.ActionsMenuWrap = styled_components_1.default.div `
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	${(0, styled_breakpoints_1.down)('xs')} {
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
	}
`;
exports.SelectionAndFinishingButtonsWrap = styled_components_1.default.div `
	display: flex;
	${(0, styled_breakpoints_1.down)('xs')} {
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		& > * {
			margin: 0.25rem 0;
		}
	}
`;
exports.ActionButtonsWrap = styled_components_1.default.div `
	display: flex;
	align-items: center;
	& > * {
		margin: 0 0.25rem;
	}
	${(0, styled_breakpoints_1.down)('xs')} {
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		& > * {
			margin: 0.5rem 0;
		}
	}
`;
exports.StyledMenu = (0, styled_components_1.default)(elements_1.Menu) `
	max-height: 400px;
	overflow-y: scroll;
	max-width: 100vw;
`;
exports.OfferActiveStatusBadge = styled_components_1.default.div `
	border-radius: 1rem;
	padding: 0 0.5rem;
	font-size: 0.75rem;
	color: ${props => props.theme.color.success};
	outline: ${props => props.theme.color.success} solid 1px;
`;
exports.OfferApplicationCountBadge = styled_components_1.default.div `
	border-radius: 1rem;
	padding: 0 0.5rem;
	font-size: 0.75rem;
	color: ${props => props.theme.color.gray7};
	outline: ${props => props.theme.color.gray7} solid 1px;
	margin-right: 0.5rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.25rem;
`;
exports.OfferTitleContainer = styled_components_1.default.div `
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	${props => {
    const applicationCountBadgeReservedSpace = 70;
    const activeOfferBadgeReservedSpace = 100;
    const totalReservedSpace = Number(props.makeSpaceForApplicationBadge) * applicationCountBadgeReservedSpace +
        Number(props.makeSpaceForActiveOfferBadge) * activeOfferBadgeReservedSpace;
    return (0, styled_components_1.css) `
			max-width: calc(100% - ${Math.max(totalReservedSpace, 20)}px);
		`;
}}
`;
exports.StyledMenuItem = (0, styled_components_1.default)(elements_1.Menu.Item) `
	.ant-dropdown-menu-title-content {
		max-width: 100%;
	}
`;
